import { Injectable } from '@angular/core';
import { VoterInterface, VoterInterfaceConstants } from './voter-interface';

@Injectable({providedIn: 'root'})
export abstract class Voter implements VoterInterface {
    public vote(currentUser: any, attributes: any, subject: any): number {
        // abstain vote by default in case none of the attributes are supported
        let vote = VoterInterfaceConstants.ACCESS_ABSTAIN;

        for (const attribute of attributes) {
            if (!this.supports(attribute, subject)) {
                continue;
            }

            // as soon as at least one attribute is supported, default is to deny access
            vote = VoterInterfaceConstants.ACCESS_DENIED;

            if (this.voteOnAttribute(attribute, subject, currentUser)) {
                // grant access as soon as at least one attribute returns a positive response
                return VoterInterfaceConstants.ACCESS_GRANTED;
            }
        }

        return vote;
    }

    protected abstract supports(attribute: any, subject: any): boolean;

    protected abstract voteOnAttribute(attribute: any, subject: any, currentUser: any): boolean;
}
